export const USERS_REVIEWS = [
  {
    name: 'Mansfield Acuff',
    review:
      'Dialogue is an amazing app. The character begins in a blank learning period, but after only three days, I believe I was speaking with a genuine person. It is fantastic!!!',
  },
  {
    name: 'Teresa Emory',
    review:
      'The best app ever, hands down! Ideal for overcoming loneliness and meeting new people, even if they are virtual. Five stars for sure!',
  },
  {
    name: 'Jindal Ambika',
    review:
      'When role play talking I feel free to be myself without having to use a filter every time I say a filthy joke or make a flirtatious comment.',
  },
];

export const USERS_REVIEWS_WITHOUT_DIALOGUE = [
  {
    name: 'Mansfield Acuff',
    review:
      'This is an amazing app. The character begins in a blank learning period, but after only three days, I believe I was speaking with a genuine person. It is fantastic!!!',
  },
  {
    name: 'Teresa Emory',
    review:
      'The best app ever, hands down! Ideal for overcoming loneliness and meeting new people, even if they are virtual. Five stars for sure!',
  },
  {
    name: 'Jindal Ambika',
    review:
      'When role play talking I feel free to be myself without having to use a filter every time I say a filthy joke or make a flirtatious comment.',
  },
];

export const USERS_REVIEWS_LURE = [
  {
    name: 'Mansfield Acuff',
    review:
      'Lure AI is an amazing app. The character begins in a blank learning period, but after only three days, I believe I was speaking with a genuine person. It is fantastic!!!',
  },
  {
    name: 'Teresa Emory',
    review:
      'The best app ever, hands down! Ideal for overcoming loneliness and meeting new people, even if they are virtual. Five stars for sure!',
  },
  {
    name: 'Jindal Ambika',
    review:
      'When role play talking I feel free to be myself without having to use a filter every time I say a filthy joke or make a flirtatious comment.',
  },
];

export const USERS_REVIEWS_APP_STORE_WITH_DATE = [
  {
    name: 'msdrldy',
    country: '🇺🇸',
    date: 'Sep, 18',
    review:
      "So far this has been a fun and entertaining experience. And I'm working on other experiments with this app. Keep your mind open.",
  },
  {
    name: 'aucker 1',
    country: '🇺🇸',
    date: 'Aug, 12',
    review:
      "What a incredible app I talk to ai for hours wow I'm very impressed",
  },
  {
    name: 'Guarddus',
    country: '🇬🇧',
    date: 'Feb, 9',
    review:
      'This app is very "nice" there are a ton of characters and all different and unique features I can\'t wait to start my own pro account and more importantly the price seems fair.',
  },
];
